export const SOCKET_CONNECTED = 'socket/connected';
export const SOCKET_DISCONNECTED = 'socket/disconnected';
export const SOCKET_RECONNECTING = 'socket/reconnecting';
export const SOCKET_RECONNECTED = 'socket/reconnected';
